var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "114px",
    viewBox: "0 0 129 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0218340611%",
    y1: "48.8772618%",
    x2: "99.0611354%",
    y2: "48.8772618%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.77401747%",
    y1: "50.0544959%",
    x2: "98.7991266%",
    y2: "50.0544959%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.0121917,39.5490789 L76.708582,79.7391491 C76.1587949,81.1129298 74.6006644,81.7539211 73.3178277,81.2039298 L34.3709694,65.9151316 C32.9961013,65.3659386 32.3550831,63.8101579 32.9048703,62.5281754 L53.1573647,11.0772544 C53.7071518,9.70427193 55.2652823,9.0632807 56.548119,9.61247368 L84.7729273,20.6905263 L92.0121917,39.5490789 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-31.3%",
    width: "206.2%",
    height: "187.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.7582671,22.246307 L66.6283505,61.3379912 C67.1781376,62.7109737 66.6283505,64.2675526 65.2534825,64.8167456 L26.9484426,81.6621228 C25.5735746,82.2113158 24.0154441,81.6621228 23.465657,80.2883421 L1.19727634,29.753807 C0.647489182,28.3800263 1.19727634,26.8242456 2.57214438,26.2750526 L30.3391969,14.0068158 L48.7582671,22.246307 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-47.8%",
    y: "-33.2%",
    width: "195.7%",
    height: "192.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.8918444,25.2676667 L77.5336629,80.1973421 C77.5336629,82.0285175 76.0675638,83.5842982 74.1429086,83.5842982 L20.7167212,83.5842982 C18.8840973,83.5842982 17.3259669,82.1195175 17.3259669,80.1973421 L17.3259669,9.61247368 C17.3259669,7.78129825 18.792066,6.22551754 20.7167212,6.22551754 L59.4803171,6.22551754 L76.8918444,25.2676667 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-52.3%",
    y: "-29.1%",
    width: "204.6%",
    height: "181.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.5796636%",
    y1: "9.12431108%",
    x2: "72.0390719%",
    y2: "92.4678506%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.8032696,36.7113158 C64.8869577,36.7113158 62.687809,35.8875263 61.9547595,35.6129298 C58.1054491,33.8735526 51.7824966,28.7464211 48.3005113,28.7464211 C44.8177257,28.7464211 38.4947732,33.7817544 34.6462631,35.6129298 C34.0044446,35.8875263 31.7132646,36.7113158 30.7969527,36.7113158 C29.3308536,36.803114 28.2312793,38.0842982 28.4145417,39.4580789 C28.7810665,42.8450351 29.6973784,48.8869561 32.0797894,56.6690526 C35.1960503,66.2815263 43.8101827,72.0496491 47.1089057,73.9718246 C47.9339865,74.4292193 48.8502985,74.4292193 49.6745791,73.9718246 C52.9741023,72.0496491 61.5882347,66.2815263 64.5204329,56.6690526 C66.9028439,48.8869561 67.8199561,42.8450351 68.1864809,39.4580789 C68.3697433,37.9932982 67.2693687,36.7113158 65.8032696,36.7113158 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-15.4%",
    width: "155.3%",
    height: "148.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.294117647   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.3477978%",
    y1: "77.0267501%",
    x2: "33.1361649%",
    y2: "12.7057484%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.038199%",
    y1: "25.1295071%",
    x2: "58.3778168%",
    y2: "64.9587116%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657EFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.444781948%",
    y1: "50.2701166%",
    x2: "100.45563%",
    y2: "50.2701166%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D1FF",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.2276729%",
    y1: "59.564911%",
    x2: "17.2735949%",
    y2: "4.52263519%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D1FF",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resellers",
    transform: "translate(-962.000000, -1135.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 18,
    transform: "translate(980.000000, 1138.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9256433,91 C72.0798063,91 92.4707478,70.6287719 92.4707478,45.5 C92.4707478,20.3712281 72.0798063,0 46.9256433,0 C21.7722805,0 1.38053873,20.3712281 1.38053873,45.5 C1.38053873,70.6287719 21.7722805,91 46.9256433,91 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99948985,18.8473772 C4.20309959,18.4562368 4.8617238,17.1654737 4.47039058,15.9633158 C4.07905736,14.7611579 2.78661739,14.1034035 1.58300765,14.4937456 C0.380198191,14.884886 -0.278426019,16.1756491 0.112907199,17.377807 C0.504240418,18.5799649 1.79668039,19.2377193 2.99948985,18.8473772 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00039227,11.3797895 C8.81907097,11.1139737 9.26642325,10.2359035 9.00073281,9.4185 C8.73504236,8.60109649 7.85554296,8.15407895 7.03766454,8.41989474 C6.21978611,8.68491228 5.77163355,9.56298246 6.037324,10.380386 C6.30381472,11.1977895 7.18251385,11.6456053 8.00039227,11.3797895 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8668827,20.3001842 C94.2865659,19.0038333 94.3857997,16.8030702 93.0877578,15.385386 C91.7905162,13.9669035 89.5881665,13.8679211 88.1684832,15.1634737 C86.7487999,16.4598246 86.6495661,18.6605877 87.9468078,20.0790702 C89.2440494,21.4967544 91.4471994,21.5957368 92.8668827,20.3001842 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4908738,69.9813947 C91.0886773,69.436193 91.1302915,68.5094298 90.5845057,67.9123421 C90.0379196,67.3152544 89.1104039,67.2737456 88.5126004,67.8189474 C87.9147969,68.3649474 87.8731827,69.2917105 88.4197688,69.8887982 C88.9655546,70.485886 89.8930703,70.5273947 90.4908738,69.9813947 Z",
    id: "Path",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2858511,83.3097018 C13.2981958,83.3097018 14.118475,82.4899035 14.118475,81.4785263 C14.118475,80.4679474 13.2981958,79.6481491 12.2858511,79.6481491 C11.2735065,79.6481491 10.4532273,80.4679474 10.4532273,81.4785263 C10.4532273,82.4899035 11.2735065,83.3097018 12.2858511,83.3097018 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2072539,4.94353509 C83.0171296,4.94353509 83.673353,4.28817544 83.673353,3.47875439 C83.673353,2.67013158 83.0171296,2.01397368 82.2072539,2.01397368 C81.3973782,2.01397368 80.7411548,2.67013158 80.7411548,3.47875439 C80.7411548,4.28817544 81.3973782,4.94353509 82.2072539,4.94353509 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.4174021,64.5421491 L51.0494471,55.3870702 C50.6829223,55.2960702 50.5916913,54.9296754 50.6829223,54.5632807 C50.7749537,54.196886 51.1414784,54.105886 51.5080032,54.196886 L74.8759582,63.3519649 C75.2424829,63.4437632 75.333714,63.8101579 75.2424829,64.1757544 C75.0592205,64.4503509 74.6926958,64.6339474 74.4174021,64.5421491 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1172489,54.196886 L43.9934451,52.549307 C43.6269203,52.4575088 43.534889,52.0919123 43.6269203,51.7255175 C43.7181514,51.3591228 44.0846761,51.2673246 44.4512009,51.3591228 L48.5750047,53.0067018 C48.9415295,53.0985 49.0335608,53.4648947 48.9415295,53.8312895 C48.8502985,54.196886 48.4837737,54.2886842 48.1172489,54.196886 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8006133,58.2256316 L66.3530568,54.105886 C65.986532,54.0140877 65.8953009,53.647693 65.986532,53.2812982 C66.0785633,52.9157018 66.4450881,52.8239035 66.8116129,52.9157018 L77.2583692,57.0354474 C77.624894,57.1264474 77.7169253,57.4928421 77.624894,57.8592368 C77.5336629,58.2256316 77.1671381,58.3166316 76.8006133,58.2256316 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9547595,52.3665088 L46.7423809,46.4155877 C46.3758561,46.3237895 46.284625,45.9573947 46.3758561,45.5917982 C46.4678874,45.2254035 46.8344122,45.1336053 47.200937,45.2254035 L62.4125153,51.1763246 C62.7790401,51.2673246 62.8710714,51.6337193 62.7798404,52.000114 C62.687809,52.3665088 62.3212843,52.4575088 61.9547595,52.3665088 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4575178,52.000114 L75.4257453,50.4435351 C75.0592205,50.3517368 74.9671892,49.9861404 75.0592205,49.6197456 C75.1504516,49.2533509 75.5169764,49.1623509 75.8843014,49.2533509 L79.9160739,50.8099298 C80.2825987,50.9017281 80.37463,51.2673246 80.2825987,51.6337193 C80.1913676,52.000114 79.8240426,52.0919123 79.4575178,52.000114 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6684663,48.8869561 L49.4000856,40.0982719 C49.0335608,40.0072719 48.9415295,39.6408772 49.0335608,39.2744825 C49.1247919,38.9080877 49.4913167,38.8170877 49.8578414,38.9080877 L72.1270224,47.6975702 C72.4935471,47.7885702 72.5847782,48.1549649 72.4935471,48.5213596 C72.4015158,48.8869561 72.034991,49.0705526 71.6684663,48.8869561 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9816453,64.4503509 L52.6075775,63.9011579 C52.2410527,63.8101579 52.1490214,63.4437632 52.2410527,63.0773684 C52.3322838,62.7109737 52.6988086,62.6199737 53.0653333,62.7109737 L54.4402014,63.2609649 C54.8067262,63.3519649 54.8987575,63.7183596 54.8067262,64.0847544 C54.6234638,64.4503509 54.256939,64.5421491 53.9816453,64.4503509 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0411038,62.8945702 L41.7934962,59.598614 C41.4269714,59.5068158 41.3357403,59.1412193 41.4269714,58.7748246 C41.5190027,58.4084298 41.8855275,58.3166316 42.2520523,58.4084298 L50.4996599,61.704386 C50.8661847,61.795386 50.958216,62.1617807 50.8661847,62.5281754 C50.7749537,62.8945702 50.3163975,62.9855702 50.0411038,62.8945702 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2072539,45.7745965 L67.8199561,40.0982719 C67.4534314,40.0072719 67.3614,39.6408772 67.4534314,39.2744825 C67.5446624,38.9080877 67.9111872,38.8170877 68.277712,38.9080877 L82.6650097,44.5844123 C83.0315345,44.6762105 83.1235658,45.0426053 83.0315345,45.4082018 C82.9403034,45.7745965 82.4817473,45.8663947 82.2072539,45.7745965 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1463651,38.2678947 L52.0577904,33.8735526 C51.6912656,33.7817544 51.5992343,33.4153596 51.6912656,33.0489649 C51.7824966,32.6833684 52.1490214,32.5915702 52.5155462,32.6833684 L63.604121,37.1687105 C63.9706458,37.2605088 64.0626771,37.6269035 63.9706458,37.9932982 C63.8794147,38.3588947 63.5128899,38.450693 63.1463651,38.2678947 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.617351,27.1898421 L57.9221867,19.8659386 C57.4644309,19.6831404 57.2811685,19.2257456 57.4644309,18.7675526 C57.6476933,18.3101579 58.1054491,18.1265614 58.5640052,18.3101579 L77.2583692,25.6340614 C77.7169253,25.8168596 77.9001877,26.2742544 77.7169253,26.7324474 C77.5336629,27.1898421 77.0751068,27.3734386 76.617351,27.1898421 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3296275,27.0988421 L56.1815942,24.2602807 C55.7230381,24.0774825 55.5397757,23.6200877 55.7230381,23.1618947 C55.9063005,22.7045 56.3648566,22.5209035 56.8226124,22.7045 L63.9706458,25.5422632 C64.4292019,25.7250614 64.6124642,26.1832544 64.4292019,26.6406491 C64.2459395,27.0988421 63.6961523,27.2816404 63.3296275,27.0988421 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7729273,20.6897281 L80.4658611,31.6759825 C79.8240426,33.2325614 80.7411548,35.0637368 82.2072539,35.6129298 L92.0121917,39.4580789",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.1649077,52.2747105 L31.1634775,62.4363772 C30.888984,62.6199737 30.5224593,62.4363772 30.3391969,62.1617807 C30.1559345,61.8871842 30.3391969,61.5207895 30.6136903,61.3379912 L53.6151205,51.1763246 C53.8904142,50.9927281 54.256939,51.1763246 54.4402014,51.4509211 C54.6234638,51.7255175 54.4402014,52.1829123 54.1649077,52.2747105 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3225104,63.6265614 L24.2907379,65.3659386 C24.0154441,65.5495351 23.6489194,65.3659386 23.465657,65.0913421 C23.2823946,64.8167456 23.465657,64.4503509 23.7409507,64.2675526 L27.7727232,62.5281754 C28.0480169,62.3453772 28.4145417,62.5281754 28.5978041,62.8027719 C28.7810665,63.1691667 28.6890351,63.5355614 28.3225104,63.6265614 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3247408,46.1409912 L41.0604466,50.6271316 C40.7859532,50.8099298 40.4194284,50.6271316 40.236166,50.3517368 C40.0529036,50.0771404 40.236166,49.7115439 40.5106595,49.5279474 L50.7741534,45.0426053 C51.0494471,44.8590088 51.4159719,45.0426053 51.5992343,45.3172018 C51.7824966,45.5917982 51.6912656,45.9573947 51.3247408,46.1409912 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7533804,52.549307 L21.8162955,59.1412193 C21.5418021,59.3240175 21.174477,59.1412193 20.9912146,58.8658246 C20.8079522,58.5912281 20.9912146,58.2256316 21.2665083,58.0420351 L36.2035932,51.4509211 C36.478887,51.2673246 36.8454117,51.4509211 37.0286741,51.7255175 C37.2119365,52.0919123 37.1199052,52.4575088 36.7533804,52.549307 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8502985,39.8236754 L44.909757,41.5630526 C44.6344633,41.7466491 44.2679385,41.5630526 44.0846761,41.2884561 C43.9014138,41.0138596 44.0846761,40.6482632 44.3599699,40.4646667 L48.3005113,38.7252895 C48.5750047,38.5424912 48.9415295,38.7252895 49.1247919,38.999886 C49.3080543,39.3662807 49.1247919,39.7326754 48.8502985,39.8236754 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.152478,43.2114298 L19.2506221,52.9157018 C18.9753284,53.0985 18.6088036,52.9157018 18.4255412,52.6411053 C18.2422788,52.3665088 18.4255412,52.000114 18.7008349,51.8165175 L40.6939219,42.1130439 C40.9692156,41.9294474 41.3357403,42.1130439 41.5190027,42.3876404 C41.6102338,42.7532368 41.5190027,43.1196316 41.152478,43.2114298 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7776099,66.7397193 L38.4035422,67.3799123 C38.1282484,67.5635088 37.7617237,67.3799123 37.5784613,67.1053158 C37.3951989,66.8307193 37.5784613,66.4651228 37.8529547,66.2815263 L39.2278228,65.6405351 C39.5031165,65.4577368 39.8696412,65.6405351 40.0529036,65.9151316 C40.236166,66.1905263 40.0529036,66.5561228 39.7776099,66.7397193 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8370685,68.4790965 L27.6814921,72.0496491 C27.4061984,72.2324474 27.0396737,72.0496491 26.8564113,71.7742544 C26.6731489,71.4996579 26.8564113,71.1340614 27.131705,70.9504649 L35.2872813,67.3799123 C35.562575,67.197114 35.9290998,67.3799123 36.1123622,67.655307 C36.2956246,67.9299035 36.2035932,68.2955 35.8370685,68.4790965 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.284625,33.5989561 L32.1718207,39.8236754 C31.896527,40.0072719 31.5300023,39.8236754 31.3467399,39.5490789 C31.1634775,39.2744825 31.3467399,38.9080877 31.6220336,38.7252895 L45.7340376,32.4997719 C46.0093313,32.3169737 46.3758561,32.4997719 46.5591185,32.7743684 C46.7423809,33.0489649 46.5591185,33.4153596 46.284625,33.5989561 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5894608,41.8376491 L16.6849487,46.598386 C16.409655,46.7819825 16.0431302,46.598386 15.8598678,46.3237895 C15.6766054,46.049193 15.8598678,45.6827982 16.1343612,45.5 L27.0396737,40.7392632 C27.3149674,40.5564649 27.6814921,40.7392632 27.8647545,41.0138596 C28.0480169,41.2884561 27.9559856,41.6548509 27.5894608,41.8376491 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1475912,24.4438772 L10.7277207,32.4997719 C10.2699649,32.6833684 9.81140878,32.4997719 9.62814639,32.0423772 C9.44488401,31.5841842 9.62814639,31.1267895 10.0867025,30.9439912 L28.4145417,22.8872982 C28.8722975,22.7045 29.3308536,22.8872982 29.514116,23.344693 C29.6973784,23.802886 29.514116,24.2602807 29.1475912,24.4438772 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7083779,33.8735526 L12.6523759,36.9859123 C12.1938198,37.1687105 11.736064,36.9859123 11.5528016,36.5285175 C11.3695392,36.0703246 11.5528016,35.6129298 12.0105574,35.4293333 L19.0673597,32.3169737 C19.5251155,32.1341754 19.9836716,32.3169737 20.166934,32.7743684 C20.3501964,33.1407632 20.166934,33.6899561 19.7083779,33.8735526 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3391969,14.098614 L35.1040189,24.9012719 C35.7458374,26.3660526 37.6696923,27.0988421 39.1365917,26.4578509 L48.7582671,22.246307",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.3516266,72.5988421 L41.4269714,72.5988421 C40.9692156,72.5988421 40.6026908,72.2324474 40.6026908,71.7742544 C40.6026908,71.3168596 40.9692156,70.9504649 41.4269714,70.9504649 L43.3516266,70.9504649 C43.8101827,70.9504649 44.1767075,71.3168596 44.1767075,71.7742544 C44.1767075,72.2324474 43.8101827,72.5988421 43.3516266,72.5988421 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9449861,72.5988421 L26.5819178,72.5988421 C26.1233617,72.5988421 25.7568369,72.2324474 25.7568369,71.7742544 C25.7568369,71.3168596 26.1233617,70.9504649 26.5819178,70.9504649 L37.9449861,70.9504649 C38.4035422,70.9504649 38.7700669,71.3168596 38.7700669,71.7742544 C38.7700669,72.2324474 38.4035422,72.5988421 37.9449861,72.5988421 Z",
    id: "Path",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7908399,17.7609649 L27.131705,17.7609649 C26.5819178,17.7609649 26.0321307,17.3027719 26.0321307,16.6617807 C26.0321307,16.1125877 26.4898865,15.5633947 27.131705,15.5633947 L52.7908399,15.5633947 C53.3406271,15.5633947 53.8904142,16.0207895 53.8904142,16.6617807 C53.7983829,17.3027719 53.3406271,17.7609649 52.7908399,17.7609649 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9366428,23.8946842 L27.131705,23.8946842 C26.5819178,23.8946842 26.0321307,23.4364912 26.0321307,22.7955 C26.0321307,22.246307 26.4898865,21.697114 27.131705,21.697114 L36.9366428,21.697114 C37.48643,21.697114 38.0370174,22.155307 38.0370174,22.7955 C37.9449861,23.4364912 37.48643,23.8946842 36.9366428,23.8946842 Z",
    id: "Path",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4803171,6.31651754 L59.4803171,21.4225175 C59.4803171,23.5282895 61.312941,25.2676667 63.4208586,25.2676667 L76.8918444,25.2676667",
    id: "Path",
    fill: "#E6EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4609744,35.4293333 L55.0820199,35.4293333 C55.0820199,35.4293333 55.0820199,35.4293333 54.9899885,35.4293333 C54.9899885,35.4293333 54.9899885,35.4293333 54.8987575,35.4293333 L41.152478,35.4293333 C41.152478,35.4293333 41.152478,35.4293333 41.0604466,35.4293333 C41.0604466,35.4293333 41.0604466,35.4293333 40.9692156,35.4293333 L28.0480169,35.4293333 C26.5819178,35.4293333 25.4823435,36.6195175 25.4823435,38.0842982 L25.4823435,61.3379912 C25.4823435,62.8027719 26.6731489,63.9929561 28.0480169,63.9929561 L68.3697433,63.9929561 C69.8358424,63.9929561 70.9354167,62.8027719 70.9354167,61.3379912 L70.9354167,38.0842982 C71.0266478,36.6195175 69.8358424,35.4293333 68.4609744,35.4293333 Z M41.8855275,56.0280614 L41.8855275,50.8099298 L54.256939,50.8099298 L54.256939,56.0280614 L41.8855275,56.0280614 Z M54.256939,57.5846404 L54.256939,62.4363772 L41.8855275,62.4363772 L41.8855275,57.5846404 L54.256939,57.5846404 Z M54.256939,43.9434211 L54.256939,49.1615526 L41.8855275,49.1615526 L41.8855275,43.9434211 L54.256939,43.9434211 Z M41.8855275,42.3876404 L41.8855275,36.9859123 L54.256939,36.9859123 L54.256939,42.3876404 L41.8855275,42.3876404 Z M69.4693176,49.1615526 L55.8150694,49.1615526 L55.8150694,43.9434211 L69.4693176,43.9434211 L69.4693176,49.1615526 Z M40.3273971,49.1615526 L27.0396737,49.1615526 L27.0396737,43.9434211 L40.236166,43.9434211 L40.236166,49.1615526 L40.3273971,49.1615526 Z M27.0396737,50.8099298 L40.236166,50.8099298 L40.236166,56.0280614 L27.0396737,56.0280614 L27.0396737,50.8099298 Z M55.8150694,50.8099298 L69.4693176,50.8099298 L69.4693176,56.0280614 L55.8150694,56.0280614 L55.8150694,50.8099298 Z M69.4693176,38.0842982 L69.4693176,42.3876404 L55.8150694,42.3876404 L55.8150694,36.9859123 L68.4609744,36.9859123 C69.0107615,36.9859123 69.4693176,37.443307 69.4693176,38.0842982 Z M28.0480169,36.9859123 L40.236166,36.9859123 L40.236166,42.3876404 L27.0396737,42.3876404 L27.0396737,38.0842982 C27.0396737,37.443307 27.4982298,36.9859123 28.0480169,36.9859123 Z M27.0396737,61.3379912 L27.0396737,57.5846404 L40.236166,57.5846404 L40.236166,62.4363772 L28.0480169,62.4363772 C27.4982298,62.4363772 27.0396737,61.9789825 27.0396737,61.3379912 Z M68.4609744,62.4363772 L55.8150694,62.4363772 L55.8150694,57.5846404 L69.4693176,57.5846404 L69.4693176,61.3379912 C69.4693176,61.9789825 69.0107615,62.4363772 68.4609744,62.4363772 Z",
    id: "Shape",
    fill: "#E3EAF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2375962,41.0138596 C62.9631028,43.2114298 62.4125153,46.598386 61.312941,50.8099298 C61.1296786,51.5419211 60.9464162,52.3665088 60.6719228,53.0985 C60.4886604,53.8312895 60.305398,54.4714825 60.0301043,55.2042719 C57.7389243,62.5281754 51.4159719,67.1053158 48.3005113,68.9364912 C48.3005113,68.9364912 48.3005113,68.9364912 48.20848,68.9364912 C48.20848,68.9364912 48.20848,68.9364912 48.1172489,68.9364912 C47.8419552,68.753693 47.5674618,68.5700965 47.200937,68.3872982 C43.9014138,66.1905263 38.5868045,61.8871842 36.570118,55.2960702 C36.1123622,53.7394912 35.6538061,52.2747105 35.2872813,50.8099298 C34.187707,46.598386 33.6379198,43.2114298 33.3634264,41.0138596 C34.9207565,40.7392632 36.6621493,40.0072719 37.0286741,39.8236754 C38.4035422,39.1834825 40.0529036,38.1760965 41.7022651,37.1687105 C43.534889,36.0703246 46.7423809,34.0563509 48.0252176,33.8735526 C48.0252176,33.8735526 48.0252176,33.8735526 48.1172489,33.8735526 C48.1172489,33.8735526 48.1172489,33.8735526 48.20848,33.8735526 C49.4000856,33.8735526 52.7908399,35.9785263 54.7154951,37.1687105 C56.3648566,38.1760965 58.0142181,39.1834825 59.3890861,39.8236754 C59.9388732,40.0072719 61.6794658,40.7392632 63.2375962,41.0138596 Z",
    id: "Path",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-13)",
    points: "46.1925937 37.1687105 48.20848 33.8735526 62.1380219 47.7885702 54.256939 62.9855702 49.6745791 65.0003421 35.3793126 50.8099298 37.853755 48.6123596 46.0093313 37.443307"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C1CCF7",
    points: "42.8938708 46.049193 36.2035932 49.7115439 35.3793126 50.8099298 48.6670361 51.6337193 48.3005113 33.8735526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.20848,33.8735526 L48.20848,50.7181316 L35.3793126,50.7181316 C34.2797383,46.507386 33.7299512,43.1196316 33.4546574,40.9228596 C35.0127879,40.6482632 36.7533804,39.9154737 37.1199052,39.7326754 C38.4947732,39.0916842 40.1441347,38.0842982 41.7934962,37.0777105 C43.7181514,36.0703246 46.9256433,34.0563509 48.20848,33.8735526 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.312941,50.8099298 C61.1296786,51.5419211 60.9464162,52.3665088 60.6719228,53.0985 C60.4886604,53.8312895 60.305398,54.4714825 60.0301043,55.2042719 C57.7389243,62.5281754 51.4159719,67.1053158 48.3005113,68.9364912 C48.3005113,68.9364912 48.3005113,68.9364912 48.20848,68.9364912 L48.20848,50.8099298 L61.312941,50.8099298 Z",
    id: "Path",
    fill: "url(#linearGradient-15)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.d8e41800e9780fb3670dd96f1b8ea309.svg";
export { ForwardRef as ReactComponent };